'use strict';

module.exports = require('../../functions/makeLang')({
	ERROR: 'Invalid email!',
	VALID_CHARS: "Check you've typed the email correctly.",
	SENDGRID_ASCII_RANGE:
		'Sorry, our email provider does not currently support those non-English characters in addresses.',
	EXISTS: 'This email is taken!',
	LOGIN: 'This account exists, please <a href="$login">Login to proceed using it</a>',
	MX:
		'$domain does not appear to be a valid email domain. Please check that you have spelt it correctly and try again.'
});
